import { DetailSummary } from "@/shared/components/ui/DetailSummary";
import { EmptyState } from "@/shared/components/ui/EmptyState";
import { Section } from "@/shared/components/ui/Section";
import { StatusBadge } from "@/shared/components/ui/StatusBadge";
import type { PhoneNumber } from "../types/phoneNumberTypes";

export function PhoneNumberSection({ phone }: { phone?: PhoneNumber }) {
  return (
    <Section title="Your number" card>
      {phone ? (
        <DetailSummary items={[
          { label: "Number", value: phone.number },
          {
            label: "Status",
            value: <StatusBadge tone={phone.status === "active" ? "positive" : "neutral"}>
              {phone.status === "active" ? "Active" : "Inactive"}
            </StatusBadge>,
          },
        ]} />
      ) : (
        <EmptyState
          title="No phone number yet"
          message="Your business doesn't have a Froppio phone number. Customers' texts and calls will use it once it's set up."
        />
      )}
    </Section>
  );
}
